<template>
    <div class="accordion border-0" :id="id">
        <div class="accordion-item border-0 rounded-0">
            <button
                class="accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0 collapsed p-15 p-sm-20 p-sm-25 p-lg-30 pe-50"
                type="button" data-bs-toggle="collapse" :data-bs-target="`#${id}-tab`" aria-expanded="false"
                aria-controls="content-permission-tab">
                <div class="d-sm-flex align-items-center justify-content-between">
                    <h5 class="fw-medium text-black-emphasis mb-0">
                        <slot name="title">
                            {{title}}
                        </slot>
                    </h5>
                </div>
            </button>
            <div :id="`${id}-tab`" class="accordion-collapse collapse border-0"
                :data-bs-parent="`#${id}`">
                <div class="accordion-body border-0 py-15 py-sm-20 p-md-25 py-sm-25 py-lg-30">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'FKAccordion',
    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false
        }
    },
});
</script>